<template>
    <div class="pr-5 prose max-w-none">
        <p>Last updated on April 27, 2021.</p>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita quisquam sunt laudantium nulla eos asperiores nostrum doloribus veritatis, tempora impedit deleniti necessitatibus voluptate blanditiis dolore tenetur accusantium dicta iusto rerum.</p>
        <p>Aliquid doloribus dolores sunt illum tenetur rerum blanditiis esse veritatis deleniti, animi fugit fugiat at assumenda magnam nemo exercitationem mollitia nisi ipsum itaque cumque labore quam ex unde? Animi, distinctio.</p>
        <p>Nobis, nulla deserunt. Labore eius suscipit reiciendis repellendus totam neque eos quod dolorem, quisquam, eum modi, vero nostrum natus alias iusto. Corporis, voluptatem. Doloribus alias distinctio ex? Quaerat, autem corrupti.</p>
        <p>Sunt laborum minus voluptatibus laudantium necessitatibus ipsam similique dolores. Architecto dolor culpa repudiandae ipsam sed dolorem nobis esse. Culpa soluta ratione eos quia praesentium debitis omnis cum hic numquam necessitatibus.</p>
        <p>Eligendi rerum, alias aperiam, non vel eaque aut fuga in ad consectetur, assumenda explicabo veniam hic? Fugiat mollitia, voluptatibus obcaecati molestias maxime cumque! Nemo vero similique expedita alias nulla tenetur!</p>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
